import { useCallback, useEffect, useState } from 'react'

const STORAGE_KEY = 'selectedVariants'

const loadFromStorage = (): Map<number, number> => {
  try {
    return new Map(JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'))
  } catch {
    return new Map()
  }
}

const useShardLibrary = () => {
  const [selectedVariantShards, setSelectedVariantShards] = useState<Map<number, number>>(
    () => loadFromStorage()
  )

  // Persist to localStorage whenever the map changes
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...selectedVariantShards]))
  }, [selectedVariantShards])

  const setVariantShards = useCallback((variantShards: Map<number, number>) => {
    setSelectedVariantShards(variantShards)
  }, [])

  const setVariantShard = useCallback((shardId: number, variantId: number) => {
    setSelectedVariantShards((prev) => {
      const next = new Map(prev)
      next.set(shardId, variantId)
      return next
    })
  }, [])

  return {
    selectedVariantShards,
    setVariantShards,
    setVariantShard,
  }
}

export default useShardLibrary
